import { render, staticRenderFns } from "./PricingAccount.vue?vue&type=template&id=18eff9c6&scoped=true"
import script from "./PricingAccount.vue?vue&type=script&lang=js"
export * from "./PricingAccount.vue?vue&type=script&lang=js"
import style0 from "./PricingAccount.vue?vue&type=style&index=0&id=18eff9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eff9c6",
  null
  
)

export default component.exports